"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiSplashScreenGameComponent = void 0;
var _pixi = require("pixi.js");
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _PixiAttractText = require("../PixiAttractText");
var _PixiDisplaySplashScreenCheckBox = require("./PixiDisplaySplashScreenCheckBox");
var _PixiSoundCheckBox = require("./PixiSoundCheckBox");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiSplashScreenGameComponent = exports.PixiSplashScreenGameComponent = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiSplashScreenGameComponent(channel, attractStyle, breadTextFont, logo) {
    var _this;
    var animate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    _classCallCheck(this, PixiSplashScreenGameComponent);
    _this = _callSuper(this, PixiSplashScreenGameComponent, ["PixiSplashScreenGameComponent"]);
    _defineProperty(_this, "currentResolve", void 0);
    _defineProperty(_this, "_logo", void 0);
    /**
     * If close is in progress.
     */
    _defineProperty(_this, "_closing", void 0);
    _defineProperty(_this, "_closed", void 0);
    _defineProperty(_this, "dialogContainer", void 0);
    _defineProperty(_this, "_pages", []);
    _defineProperty(_this, "_currentPage", 0);
    _defineProperty(_this, "_pagnators", void 0);
    _defineProperty(_this, "unsub", void 0);
    _defineProperty(_this, "logoInterval", void 0);
    _defineProperty(_this, "_button", void 0);
    /** meassured width, not wtih animations  */
    _defineProperty(_this, "WIDTH", 670);
    _defineProperty(_this, "_continueText", void 0);
    _defineProperty(_this, "_pagContainer", void 0);
    /**The Splash screen checkbox, exposed for changes to child class */
    _defineProperty(_this, "_splashCB", void 0);
    _defineProperty(_this, "_soundCB", void 0);
    _defineProperty(_this, "_animate", void 0);
    _defineProperty(_this, "_pagesSet", void 0);
    _defineProperty(_this, "_channel", void 0);
    _defineProperty(_this, "show", function () {
      _this.visible = true;
      _this.alpha = 1;
    });
    _defineProperty(_this, "_closeThrottle", void 0);
    _this._channel = channel;
    _this.alpha = 0;
    _this.dialogContainer = new _pixi.Container();
    _this.dialogContainer.sortableChildren = true;
    _this._animate = animate;
    _this.interactive = true;
    _this.on('mousedown', _this.backClick.bind(_this));
    _this.on('touchend', _this.backClick.bind(_this));
    _this._logo = logo;
    _this._logo.visible = true;
    _this.logoInterval = setInterval(_this._logo.win.bind(_this._logo), 15000);
    _this.dialogContainer.addChild(_this._logo);
    _this._logo.zIndex = 10;

    // prevents overlay click from triggering inside the dialog.
    _this.dialogContainer.interactive = true;
    _this.dialogContainer.on('mousedown', _this.dialogContainerClick.bind(_this));
    _this.dialogContainer.on('touchend', _this.dialogContainerClick.bind(_this));
    //#endregion

    //#region Sound control
    _this._soundCB = new _PixiSoundCheckBox.PixiSoundCheckBox("SplSoundCheckBox", breadTextFont);
    _this.dialogContainer.addChild(_this._soundCB);
    //#endregion

    //#region  CheckBox
    if (channel != _core.Channel.Mobile) {
      _this._splashCB = new _PixiDisplaySplashScreenCheckBox.PixiDisplaySplashScreenCheckBox("SplDisplaySplashScreenCheckBox", breadTextFont);
      _this.dialogContainer.addChild(_this._splashCB);
    }
    //#endregion

    //#region Play/continue
    _this._button = new _pixi.Container();
    var buttonSprite = new _pixi.Sprite(_pixi.Texture.from('spl_playbutton.png'));
    buttonSprite.anchor.set(0.5);
    _this._button.addChild(buttonSprite);
    buttonSprite.interactive = true;
    buttonSprite.buttonMode = true;
    buttonSprite.on('mousedown', _this._playbuttonPress.bind(_this));
    buttonSprite.on('touchstart', _this._playbuttonPress.bind(_this));
    _this._button.y = 404;
    _this._button.x = 0;
    _this.dialogContainer.addChild(_this._button);

    // note the text is not IN the button, since we do that the text is also "interactice and with the animation that means the button is large than it actually is"
    _this._continueText = new _PixiAttractText.PixiAttractText("PlayAttractText", _core.CORE.translate("splashDesktopTextContinue"), attractStyle);
    _this._continueText.y = -12;
    _this._button.addChild(_this._continueText);
    _this.addChild(_this.dialogContainer);
    _this.dialogContainer.name = "dialog";
    _this.unsub = _core.CORE.subscribe('config.splashScreen', function (show) {
      if (show) _this.show();else _this.hide();
    });
    return _this;
  }
  _inherits(PixiSplashScreenGameComponent, _PixiGameComponent);
  return _createClass(PixiSplashScreenGameComponent, [{
    key: "backClick",
    value: function backClick(e) {
      // console.log('base');
      e.stopPropagation();
      this.skipAnimation();
    }
  }, {
    key: "dialogContainerClick",
    value: function dialogContainerClick(e) {
      //  console.log('dialog');
      e.stopPropagation();
      this.skipAnimation();
    }

    /**
     * Define the pages to be used-
     * @param pages 
     */
  }, {
    key: "setPages",
    value: function setPages(pages) {
      var _this$dialogContainer,
        _this2 = this;
      if (this._pagesSet) {
        console.warn('pages already set, will lead to wierd results.');
        return;
      }
      this._pagesSet = true;
      this._pages = pages;
      if (this._pages && this._pages.length < 0) {
        for (var index = 0; index < this._pages.length; index++) {
          this._pages[index].destroy();
          this._pagnators[index].destroy();
        }
      }
      if (this._pages.length > 0) (_this$dialogContainer = this.dialogContainer).addChild.apply(_this$dialogContainer, _toConsumableArray(this._pages));
      if (this._pages.length >= 1) {
        if (this._pagContainer) this._pagContainer.destroy();
        this._pagContainer = new _pixiGame.CustomPixiContainer();
        this._pagnators = [];
        var _loop = function _loop(_index) {
            pag = new _pixi.Sprite();
            pag.anchor.set(0.5);
            pag.x = 60 * _index;
            _this2._pagnators.push(pag);
            _this2._pagContainer.addChild(pag);
            pag.buttonMode = true;
            pag.interactive = true;
            pag.on('mousedown', function (e) {
              e.stopPropagation();
              _this2.showPage(_index);
            });
            pag.on('touchstart', function (e) {
              e.stopPropagation();
              _this2.showPage(_index);
            });
            _this2._pages[_index].interactive = true;
            _this2._pages[_index].on('mousedown', function (e) {
              _this2.nextPage();
            });
            _this2._pages[_index].on('touchstart', function (e) {
              _this2.nextPage();
            });
          },
          pag;
        for (var _index = 0; _index < this._pages.length; _index++) {
          _loop(_index);
        }
        this._pagContainer.setAnchor(0.5);
        this._pagContainer.y = 311;
        this._pagContainer.x = 0;
        if (this._pagnators.length > 1) this.dialogContainer.addChild(this._pagContainer);
      }
      this.showPage(0);
    }
  }, {
    key: "showPage",
    value: function showPage(i) {
      if (!this._pagnators || this._pagnators.length < 1) return;
      if (this._closing) return;
      this._updatePageIndicators();
      if (this._currentPage == i) {
        for (var index = 0; index < this._pages.length; index++) {
          this._pages[index].visible = false;
        }
        this._pages[this._currentPage].visible = true;
        return;
      }
      if (this._animate) {
        // console.log('show page ' + i + ' from ' + this._currentPage)
        for (var _index2 = 0; _index2 < this._pages.length; _index2++) {
          this._pages[_index2].visible = false;
          _gsap["default"].killTweensOf(this._pages[_index2]);
        }
        this._pages[this._currentPage].visible = true;
        this._pages[this._currentPage].alpha = 1;
        _gsap["default"].to(this._pages[this._currentPage], {
          duration: 0.5,
          x: -1200,
          alpha: 0
          //  ease: "power1.in"
        });
        this._currentPage = i;
        this._pages[this._currentPage].x = 1200;
        this._pages[this._currentPage].alpha = 0;
        this._pages[this._currentPage].visible = true;
        _gsap["default"].to(this._pages[this._currentPage], {
          duration: 0.5,
          x: 0,
          alpha: 1,
          ease: "power1.out"
        });
        this._updatePageIndicators();
      } else {
        this._currentPage = i;
        for (var _index3 = 0; _index3 < this._pages.length; _index3++) {
          this._pages[_index3].visible = false;
          this._pagnators[_index3].texture = _pixi.Texture.from("spl_select.png");
        }
        if (this._pages.length > 0) {
          this._pagnators[i].texture = _pixi.Texture.from("spl_select_active.png");
          this._pages[i].visible = true;
        }
      }
    }
  }, {
    key: "_updatePageIndicators",
    value: function _updatePageIndicators() {
      if (!this._pagnators) return;
      for (var index = 0; index < this._pagnators.length; index++) {
        this._pagnators[index].texture = _pixi.Texture.from("spl_select.png");
      }
      this._pagnators[this._currentPage].texture = _pixi.Texture.from("spl_select_active.png");
    }
  }, {
    key: "nextPage",
    value: function nextPage() {
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, 'uiclick'));
      this.showPage(Math.abs((this._currentPage + 1) % this._pages.length));
    }
  }, {
    key: "prevPage",
    value: function prevPage() {
      if (this._closing) return;
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, 'uiclick'));
      this._currentPage--;
      if (this._currentPage < 0) this._currentPage = this._pages.length - 1;
      this.showPage(Math.abs(this._currentPage % this._pages.length));
    }
  }, {
    key: "onResize",
    value: function onResize(c) {
      this.scale.set(1);
      switch (c.channel) {
        case _core.Channel.Mobile:
          {
            this._soundCB.setAnchor(0.5);
            this._soundCB.x = 0;
            this._soundCB.y = 354 + 100;
            switch (c.orientation) {
              case _core.Orientation.Portrait:
                {
                  this.scale.set(c.width / this.WIDTH);
                  this._soundCB.scale.set(1);
                  this._soundCB.y = 354 + 160;
                  this._button.y = 400;

                  // tablets, spec for ipad and ipad pro
                  if (c.width > 766) {
                    this.scale.set(c.width / (this.WIDTH + 260));
                  }

                  // this is to handle very small portriat
                  if (c.height < this.dialogContainer.height * this.scale.x) {
                    this.scale.set(c.height / (this.dialogContainer.height + 100));
                  }
                  break;
                }
              default:
                {
                  this._button.y = 380;
                  this._soundCB.scale.set(1);
                  this.scale.set(c.scaleFactor * 0.9);
                  break;
                }
            }
            break;
          }
        default:
          {
            //desktop
            this.scale.set(c.scaleFactorHd);
          }
      }
      this.x = c.width / 2;
      this.y = c.height / 2;

      // set the click area of this. since this is scaled and centered/pivoted we have to work magic
      this.hitArea = new _pixi.Rectangle(-(c.width / 2 / this.scale.x), -(c.height / 2 / this.scale.y), 10000, 10000);
    }
  }, {
    key: "hide",
    value: function hide() {
      // allow for hide to fire twice... something with the subscrptiion
      if (this._destroyed) return;
      this._destroyed = true;
      clearInterval(this.logoInterval);
      this.visible = false;
      if (this.unsub) this.unsub();
      if (this.currentResolve) this.currentResolve();
      this.destroy({
        children: true
      });
    }
  }, {
    key: "destroy",
    value: function destroy(options) {
      var _this$_splashCB, _this$_soundCB;
      _gsap["default"].killTweensOf(this._pages);
      (_this$_splashCB = this._splashCB) === null || _this$_splashCB === void 0 || _this$_splashCB.destroy(options);
      (_this$_soundCB = this._soundCB) === null || _this$_soundCB === void 0 || _this$_soundCB.destroy(options);
      _superPropGet(PixiSplashScreenGameComponent, "destroy", this, 3)([options]);
    }
  }, {
    key: "_playbuttonPress",
    value: function _playbuttonPress(e) {
      var _this3 = this;
      if (this._closeThrottle) return;
      this._closeThrottle = true;
      setTimeout(function () {
        _this3._closeThrottle = false;
      }, 200);
      if (this._closing) {
        _core.CORE.dispatch({
          type: _core.HIDE_SPLASH_SCREEN
        });
        return;
      }
      e.stopPropagation();
      this.playButtonPress();
    }
  }, {
    key: "playButtonPress",
    value: function playButtonPress() {
      if (this._closed) return;
      // can also be set in the override, when closing is animated
      this._closed = true;
      _core.CORE.dispatch({
        type: _core.HIDE_SPLASH_SCREEN
      });
      // we dont play sound here, sounds sould not be played in shared comps
    }
  }, {
    key: "skipAnimation",
    value: function skipAnimation() {
      if (this._closing && !this._closeThrottle) {
        _core.CORE.dispatch({
          type: _core.HIDE_SPLASH_SCREEN
        });
        return;
      }
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiSplashScreenGameComponent.js.map